export const INCIDENT_DATE = "incidentDate";
export const ASSIGNED_STATUS = "assignedStatus";
export const QA_ANALYST_ID = "qaAnalystId";
export const VALIDATION_TYPE_IDS = "validationTypeIds";
export const STATUS = "status";
export const IS_VALID = "isValid";
export const ENROLLMENT_ID = "enrollmentId";
export const SALE_ID = "saleId";
export const ACCOUNT_NUMBER = "accountNumber";
export const CUSTOMER_PHONE = "customerPhone";
export const CUSTOMER_NAME = "customerName";
export const HAS_CUSTOMER_INCIDENT = "hasCustomerIncident";
export const BRANCH_IDS = "branchIds";
export const REP_IDS = "repIds";
export const ACTIVE_REPS_ONLY = "activeRepsOnly";
